import React, { useState, useEffect } from "react";
import api from "../api/axiosInstance";
import ProfileField from "./ProfileField";
import "../style/profile.css";
import { FaEdit, FaSave, FaUser, FaBuilding, FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";

const API_URL = "https://ctmapi.zerlak.com/api/v1/profiles";
const PROFILE_ID = 1; // Change if needed

const Profile = () => {
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    company: "",
  });

  const [isEditing, setIsEditing] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [originalProfile, setOriginalProfile] = useState({});
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  // ✅ Load Profile From Backend
  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      console.log("Fetching profile...");
      
      const res = await api.get(`${API_URL}/getById/${PROFILE_ID}`);
      console.log("Profile response:", res.data);
      
      setProfile(res.data);
      setOriginalProfile(res.data);
      setError("");
    } catch (error) {
      console.error("Error fetching profile:", error);
      setError("Failed to fetch profile data");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Update Profile
  const handleEditSave = async () => {
    if (isEditing) {
      try {
        await api.put(`${API_URL}/updateById/${PROFILE_ID}`, profile);
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 2000);
        setOriginalProfile(profile);
      } catch (error) {
        console.error("Update failed:", error);
      }
    }
    setIsEditing(!isEditing);
  };

  // ✅ Cancel Edit
  const handleCancel = () => {
    setProfile(originalProfile);
    setIsEditing(false);
  };

  return (
    <div className="profile-page">
      <div className="profile-container">
        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}
        {showSuccess && (
          <div className="alert alert-success">
            Profile updated successfully!
          </div>
        )}
        
        {loading ? (
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Loading profile...</p>
          </div>
        ) : (

        <div className="profile-card">
          <div className="profile-header">
            <div className="profile-header-left">
              <div className="profile-avatar">
                <FaUser />
              </div>
              <div className="profile-details">
                <h2 className="profile-title">Business Profile</h2>
              </div>
            </div>

            <div className="profile-header-right">
              {isEditing && (
                <button
                  className="edit-btn cancel-mode"
                  onClick={handleCancel}
                >
                  <span>Cancel</span>
                </button>
              )}
              <button
                className={`edit-btn ${isEditing ? "save-mode" : "edit-mode"}`}
                onClick={handleEditSave}
              >
                {isEditing ? <FaSave /> : <FaEdit />}
                <span>{isEditing ? "Save" : "Edit"}</span>
              </button>
            </div>
          </div>

          <div className="profile-grid">
            <ProfileField
              label="Business Name"
              name="name"
              value={profile.name}
              onChange={handleChange}
              disabled={!isEditing}
              placeholder="Enter your business name"
              icon={<FaBuilding />}
            />
            {/* <ProfileField
              label="Company"
              name="company"
              value={profile.company}
              onChange={handleChange}
              disabled={!isEditing}
              placeholder="Enter company name"
              icon={<FaBuilding />}
            /> */}
            <ProfileField
              label="Email Address"
              name="email"
              value={profile.email}
              onChange={handleChange}
              disabled={!isEditing}
              placeholder="business@example.com"
              icon={<FaEnvelope />}
            />
            <ProfileField
              label="Phone Number"
              name="phone"
              value={profile.phone}
              onChange={handleChange}
              disabled={!isEditing}
              placeholder="+91 9876543210"
              icon={<FaPhone />}
            />
            <ProfileField
              label="Business Address"
              name="address"
              value={profile.address}
              onChange={handleChange}
              disabled={!isEditing}
              placeholder="Enter address"
              icon={<FaMapMarkerAlt />}
            />
          </div>
        </div>
        )}
      </div>
    </div>
  );
};;

export default Profile;
